


























































import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { Action, Getter } from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import { SelectWings, ToggleWings, InputWings } from "wings-ui-components";
import { ApplicationAttributeFilterParams } from '@/store/push/attributes/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class ApplicationAttributesFilter extends BaseFilter<ApplicationAttributeFilterParams>{
  @PropSync('show') is_show!: boolean;
  @Prop() application!: number;
  @Getter("attributeTypeList") attributeTypeList: any;
  @Getter("attributeOwnerList") attributeOwnerList: any;
  @Action("getApplicationAttributes") actionGetApplicationAttributes: any;

  defaultFilter(): ApplicationAttributeFilterParams {
    return {
      name: undefined,
      type: undefined,
      owner: undefined,
    }
  }

  mounted() {
    if (this.application) this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Push application attribute",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetApplicationAttributes({application_id: this.application, filter: this.filter})
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  @Watch('application')
  onApplication(val?:number, oldVal?:number){
    if (val) this.filtered();
  }
}
